import {
  UploadDetailKind,
  UploadRow,
  UploadRowDetail,
} from 'src/pages/ClinicalTrial/SupportSubjectList/Uploads/types';

export const isDetail = (row: UploadRow): row is UploadRowDetail =>
  row.type === 'detail';

const SUBHEADER_KINDS: UploadDetailKind[] = [
  UploadDetailKind.SUBHEADER_EXEC,
  UploadDetailKind.SUBHEADER_ASSETS,
];

export const isSubheader = (row: UploadRowDetail): boolean =>
  SUBHEADER_KINDS.includes(row.detailKind);

const ASSET_KINDS: UploadDetailKind[] = [
  UploadDetailKind.ASSETS,
  UploadDetailKind.SUBHEADER_ASSETS,
];

export const isAssets = (row: UploadRow): row is UploadRowDetail =>
  isDetail(row) && ASSET_KINDS.includes(row.detailKind);
